<div class="menubar-hoverable header-fixed menubar-pin" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  ">

  <div id="base" class="id-main-container">
    <div *ngIf="initialLoading" class="full-screen-loader-wrapper">
      <app-new-loader></app-new-loader>
    </div>

    <div *ngIf="!showPreview && !initialLoading" class="id-card-data">
      <div class="page-name-id-card">{{ 'idCard' | translate }}</div>

      <!-- Tabs Navigation -->
      <ul class="nav nav-tabs" style="margin-top: 15px;">
        <li class="nav-item" (click)="switchTab('student')" [class.disabled]="!studentServiceEnabled"
          [class.active]="activeTab === 'student'">
          <a class="nav-link" [ngClass]="{'active': activeTab === 'student'}">
            {{ 'STUDENTS' | translate }}
          </a>
        </li>

        <li class="nav-item" (click)="switchTab('staff')" [class.disabled]="!staffServiceEnabled"
          [class.active]="activeTab === 'staff'">
          <a class="nav-link" [ngClass]="{'active': activeTab === 'staff'}">
            {{ 'STAFFS' | translate }}
          </a>
        </li>
      </ul>

      <div *ngIf="serviceDisabledMessage" class="disabled-screen">
        <ng-container [ngSwitch]="serviceDisabledMessage">
      
          <span *ngSwitchCase="'STUDENT'">
            {{ 'studentIdCardDisabled' | translate:{ brandName: brand.name } }}
          </span>
      
          <span *ngSwitchCase="'STAFF'">
            {{ 'staffIdCardDisabled' | translate:{ brandName: brand.name } }}
          </span>
      
        </ng-container>
      </div>


      <!-- Student Tab Content -->
      <div class="table-data-id-card" [class.active]="activeTab === 'student'" *ngIf="activeTab === 'student'">


        <div>
          <div class="table-data-id">
            <div class="service-refresh-button">
              <div class="heading-id-service">{{ 'pendingService' | translate }}</div>
              <div [ngClass]="isRefreshing ? 'refresh-button rotate' : 'refresh-button'">
                <i class="ri-restart-line" (click)="refreshList()"></i>
              </div>
            </div>

            <div class="table-container-id-list">
              <div class="table-scroll">
                <table class="table-data-id-card-main">
                  <thead>
                    <tr>
                      <th>{{ 'serviceId' | translate }}</th>
                      <th class="count-data">{{ 'count' | translate }}</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let key of idCardJobList">
                      <td>#{{ key.serviceId }}</td>
                      <td (click)="openStudentDetailsForTc(key.pkJobDetailId)" class="count-number-tc">
                        {{ key.scheduledStudentCount }}
                      </td>
                      <td [ngClass]="{
                          'pending-state': key.jobStatus === 'pending',
                          'generated-state': key.jobStatus === 'done',
                          'cancelled-state': key.jobStatus === 'cancelled',
                          'inprogress-state': key.jobStatus === 'inprogress'
                        }">
                        <ng-container *ngIf="
                            key.jobStatus === 'cancelled' &&
                            key.isAllIdCardGenerated !== 1
                          ">
                          ---
                        </ng-container>
                        <ng-container *ngIf="key.jobStatus === 'inprogress'">
                          <i class="ri-history-fill"></i>{{ 'inProgress' | translate }}
                        </ng-container>
                        <ng-container *ngIf="key.jobStatus === 'pending'">
                          <i class="ri-history-fill tc-icon-space"></i>{{ 'pending' | translate }}
                        </ng-container>
                        <ng-container *ngIf="key.isAllIdCardGenerated === 1">
                          <span class="tc-view-icon" (click)="handleViewButton(key.pkJobDetailId,key.serviceId)">
                            <i class="ri-eye-line tc-icon-space"></i>
                            {{ 'view' | translate }}
                          </span>
                        </ng-container>
                      </td>

                      <td [ngClass]="{
                          'generated-state': key.jobStatus === 'inprogress',
                          'cancelled-state': key.jobStatus === 'pending',
                          'edit-state': key.isAllIdCardGenerated === 1,
                          'default-state': true
                        }">
                        <button [disabled]="updatingList" (click)="openPopUpForJobCancellation(key.pkJobDetailId)"
                          class="button-cancel" *ngIf="key.jobStatus === 'pending'">
                          {{ 'cancel' | translate }}
                        </button>

                        <span class="edit-tc-format" (click)="
                            openPopUpForEditJob(
                              key.excelTemplateUrl,
                              key.pkJobDetailId
                            )
                          " *ngIf="
                            key.isAllIdCardGenerated === 1 &&
                            key.jobStatus === 'done'
                          ">
                          <i class="ri-edit-line tc-icon-space"></i>{{ 'edit' | translate }}
                        </span>

                        <span class="cancelled-tc-state" *ngIf="
                            (key.jobStatus !== 'pending' &&
                              key.jobStatus !== 'inprogress' &&
                              key.isAllIdCardGenerated !== 1) ||
                            key.jobStatus === 'cancelled'
                          ">{{ 'cancelled' | translate }}</span>
                      </td>
                    </tr>
                    <tr *ngIf="idCardJobList.length==0">
                      <td class="no-data-center" colspan="4">{{ 'noDataAvailable' | translate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="upload-section">
            <input class="file-for-id" (change)="fileUploadExcel($event)" class="upload-excel" accept=".xls, .xlsx"
              type="file" id="file-for-id">
            <label (click)="openIdCardTemplateUpload($event);$event.stopPropagation()" class="button-upload-section">
              <div class="upload-text">
                <i class="ri-upload-2-line"></i> {{ 'uploadExcel' | translate }}
              </div>
              <button class="download-btn" (click)="openIdCardTemplate($event);$event.stopPropagation()">
                {{ 'download' | translate }}
              </button>
              <div class="link">
                <span>{{ 'or' | translate }} </span><span (click)="navigateToStudentPage()"
                  class="link-to-student-page">{{ 'visitStudentPage' | translate }}</span>
              </div>
              <app-new-loader *ngIf="initialLoading"></app-new-loader>
            </label>
          </div>
        </div>

        <div class="preview-id">
          <div class="image-id-card">
            <div class="multiple-template" *ngFor="let id of idCardTemplates; let index = index">
              <div class="template-name">{{ 'template' | translate }} {{ index + 1 }}</div>
              <img class="img-for-id-multiple" src="{{ id.defaultTemplateImageUrl }}" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- Staff Tab Content -->
      <div class="table-data-id-card" [class.active]="activeTab === 'staff'" *ngIf="activeTab === 'staff'">
        <div>
          <div class="table-data-id">
            <div class="service-refresh-button">
              <div class="heading-id-service">{{ 'pendingService' | translate }}</div>
              <div [ngClass]="isRefreshing ? 'refresh-button rotate' : 'refresh-button'">
                <i class="ri-restart-line" (click)="refreshList()"></i>
              </div>
            </div>

            <div class="table-container-id-list">
              <div class="table-scroll">
                <table class="table-data-id-card-main">
                  <thead>
                    <tr>
                      <th>{{ 'serviceId' | translate }}</th>
                      <th class="count-data">{{ 'count' | translate }}</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let key of idCardJobList">
                      <td>#{{ key.serviceId }}</td>
                      <td (click)="openStaffDetailsForIdCard(key.pkJobDetailId)" class="count-number-tc">
                        {{ key.scheduledStaffCount }}
                      </td>
                      <td [ngClass]="{
                          'pending-state': key.jobStatus === 'pending',
                          'generated-state': key.jobStatus === 'done',
                          'cancelled-state': key.jobStatus === 'cancelled',
                          'inprogress-state': key.jobStatus === 'inprogress'
                        }">
                        <ng-container *ngIf="
                            key.jobStatus === 'cancelled' &&
                            key.isAllIdCardGenerated !== 1
                          ">
                          ---
                        </ng-container>
                        <ng-container *ngIf="key.jobStatus === 'inprogress'">
                          <i class="ri-history-fill"></i>{{ 'inProgress' | translate }}
                        </ng-container>
                        <ng-container *ngIf="key.jobStatus === 'pending'">
                          <i class="ri-history-fill tc-icon-space"></i>{{ 'pending' | translate }}
                        </ng-container>
                        <ng-container *ngIf="key.isAllIdCardGenerated === 1">
                          <span class="tc-view-icon" (click)="handleStaffViewButton(key.pkJobDetailId,key.serviceId)">
                            <i class="ri-eye-line tc-icon-space"></i>
                            {{ 'view' | translate }}
                          </span>
                        </ng-container>
                      </td>

                      <td [ngClass]="{
                          'generated-state': key.jobStatus === 'inprogress',
                          'cancelled-state': key.jobStatus === 'pending',
                          'edit-state': key.isAllIdCardGenerated === 1,
                          'default-state': true
                        }">
                        <button [disabled]="updatingList" (click)="openPopUpForStaffJobCancellation(key.pkJobDetailId)"
                          class="button-cancel" *ngIf="key.jobStatus === 'pending'">
                          {{ 'cancel' | translate }}
                        </button>

                        <span class="edit-tc-format" (click)="
                            openPopUpForEditStaffJob(
                              key.excelTemplateUrl,
                              key.pkJobDetailId
                            )
                          " *ngIf="
                            key.isAllIdCardGenerated === 1 &&
                            key.jobStatus === 'done'
                          ">
                          <i class="ri-edit-line tc-icon-space"></i>{{ 'edit' | translate }}
                        </span>

                        <span class="cancelled-tc-state" *ngIf="
                            (key.jobStatus !== 'pending' &&
                              key.jobStatus !== 'inprogress' &&
                              key.isAllIdCardGenerated !== 1) ||
                            key.jobStatus === 'cancelled'
                          ">{{ 'cancelled' | translate }}</span>
                      </td>
                    </tr>
                    <tr *ngIf="idCardJobList.length==0">
                      <td class="no-data-center" colspan="4">{{ 'noDataAvailable' | translate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="upload-section">
            <input class="file-for-id" (change)="staffFileUploadExcel($event)" class="upload-excel" accept=".xls, .xlsx"
              type="file" id="file-for-id">
            <label (click)="openIdCardTemplateUpload($event);$event.stopPropagation()" class="button-upload-section">
              <div class="upload-text">
                <i class="ri-upload-2-line"></i> {{ 'uploadExcel' | translate }}
              </div>
              <button class="download-btn" (click)="openIdCardTemplate($event);$event.stopPropagation()">
                {{ 'download' | translate }}
              </button>
              <div class="link">
                <span>{{ 'or' | translate }} </span><span (click)="navigateToStaffPage()"
                  class="link-to-student-page">{{ 'visitStaffPage' | translate }}</span>
              </div>
            </label>
          </div>
        </div>

        <div class="preview-id">
          <div class="image-id-card">
            <div class="multiple-template" *ngFor="let id of idCardTemplates; let index = index">
              <div class="template-name">{{ 'template' | translate }} {{ index + 1 }}</div>
              <img class="img-for-id-multiple" src="{{ id.defaultTemplateImageUrl }}" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-view-id-card (backArrowClicked)="handleBackArrowClick()" [serviceId]="selectedServiceId"
      [jobId]="selectedJobIdForPreview" [activeTab]="activeTab" *ngIf="showPreview "></app-view-id-card>

    <app-view-id-card (backArrowClicked)="handleBackArrowClick()" [serviceId]="selectedServiceId"
      [jobId]="selectedJobIdForPreview" [activeTab]="activeTab" *ngIf="showPreview "></app-view-id-card>

    <div class="modal" id="studentDetailsTc" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content student-tc-list">
          <div>
            <div class="modal-body student-list-heading">
              <span class="student-list-heading-font">{{ 'studentList' | translate }}</span>
              <span class="close-button-student-list" (click)="closePopOfStudentList()"><i
                  class="ri-close-line"></i></span>
            </div>
            <table class="student-tc-info">
              <thead class="student-info-header">
                <tr class="student-tc-header-info">
                  <th>{{ 'registrationId' | translate }}</th>
                  <th>{{ 'name' | translate }}</th>
                  <th>{{ 'class' | translate }}</th>
                  <th>{{ 'section' | translate }}</th>
                </tr>
              </thead>

              <ng-container *ngIf="studentListForTc && studentListForTc.length > 0">
                <tbody *ngIf="studentListForTc && studentListForTc.length > 0" class="student-tc-info-body">
                  <tr *ngFor="let item of studentListForTc">
                    <td>{{ item.registrationId }}</td>
                    <td>{{ item.studentName }}</td>
                    <td>{{ item.className }}</td>
                    <td>{{ item.classNumber }}</td>
                  </tr>
                </tbody>
              </ng-container>
            </table>
          </div>

          <div *ngIf="fetchingStudentList" class="student-list-loader">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal" id="staffDetailsIdCard" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content student-tc-list">
          <div>
            <div class="modal-body student-list-heading">
              <span class="student-list-heading-font">{{ 'staffList' | translate }}</span>
              <span class="close-button-student-list" (click)="closePopOfStaffList()"><i
                  class="ri-close-line"></i></span>
            </div>
            <table class="student-tc-info">
              <thead class="student-info-header">
                <tr class="student-tc-header-info">
                  <th>{{ 'registrationId' | translate }}</th>
                  <th>{{ 'staffName' | translate }}</th>
                </tr>
              </thead>

              <ng-container *ngIf="staffListForTc && staffListForTc.length > 0">
                <tbody *ngIf="staffListForTc && staffListForTc.length > 0" class="student-tc-info-body">
                  <tr *ngFor="let item of staffListForTc">
                    <td>{{ item.registrationId }}</td>
                    <td>{{ item.staffName }}</td>
                  </tr>
                </tbody>
              </ng-container>
            </table>
          </div>

          <div *ngIf="fetchingStaffList" class="student-list-loader">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="idCardTemplate" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="id-card-selection">
          <div class="heading-id-card-selection">
            {{ 'selectTemplateToDownloadExcel' | translate }}
          </div>
          <div class="id-image">
            <div *ngFor="let key of idCardTemplates" class="id-card-image" (click)="selectIdCard(key.templateId)">
              <div class="selection-container">
                <div *ngIf="key.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
                <div *ngIf="!key.isSelected" class="selection-icon"></div>
              </div>
              <img [src]="key.defaultTemplateImageUrl" alt="" />
            </div>
          </div>

          <div class="button-for-id-card">
            <button class="cancel-btn" (click)="closeIdCardTemplate()">
              {{ 'cancel' | translate }}
            </button>
            <button (click)="downloadSelectedTemplate()" class="download-btn-id-template">{{ 'download' | translate
              }}</button>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="idCardTemplateForUpload" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="id-card-selection">
          <div class="heading-id-card-selection">
            {{ 'selectTemplateToGenerateIdCards' | translate }}
          </div>
          <div class="id-image">
            <div *ngFor="let key of idCardTemplates" class="id-card-image" (click)="selectIdCard(key.templateId)">
              <div class="selection-container">
                <div *ngIf="key.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
                <div *ngIf="!key.isSelected" class="selection-icon"></div>
              </div>
              <img [src]="key.defaultTemplateImageUrl" alt="" />
            </div>
          </div>

          <div class="button-for-id-card">
            <button class="cancel-btn" (click)="closeIdCardTemplateUpload()">
              {{ 'cancel' | translate }}
            </button>
            <label class="download-btn-id-template-id" for="file-for-id">
              {{ 'proceed' | translate }}
            </label>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="cancelJob" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content tc-job-cancel-modal">
          <div class="modal-body tc-cancel-message">
            {{ 'cancelIdGeneration' | translate }}
          </div>
          <div class="tc-cancel-buttons">
            <button (click)="closeJobCancellationPopup()" class="no-button">
              {{ 'no' | translate }}
            </button>
            <button [disabled]="tcCancelling" class="yes-button" (click)="cancelSelectedJob()">
              <app-button-loader *ngIf="tcCancelling"></app-button-loader>
              <span *ngIf="!tcCancelling">{{ 'yes' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="cancelStaffJob" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content tc-job-cancel-modal">
          <div class="modal-body tc-cancel-message">
            {{ 'cancelIdGeneration' | translate }}
          </div>
          <div class="tc-cancel-buttons">
            <button (click)="closeStaffJobCancellationPopup()" class="no-button">
              {{ 'no' | translate }}
            </button>
            <button [disabled]="tcCancelling" class="yes-button" (click)="cancelSelectedStaffJob()">
              <app-button-loader *ngIf="tcCancelling"></app-button-loader>
              <span *ngIf="!tcCancelling">{{ 'yes' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="editJob" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content tc-job-cancel-modal">
          <div class="modal-body tc-cancel-message">
            {{ 'editServices' | translate }}
          </div>

          <div class="message-edit">
            {{ 'editMessage' | translate }}
          </div>
          <div class="tc-cancel-buttons">
            <button (click)="closePopUpForEditJob()" class="no-button">
              {{ 'no' | translate }}
            </button>
            <button class="yes-button">
              <app-button-loader *ngIf="tcCancelling"></app-button-loader>
              <span (click)="downloadTemplateForEdit()" class="proceed-edit">
                {{ 'proceed' | translate }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

        <div class="modal fade" id="staffEditJob" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-tc-cancel" role="document">
        <div class="modal-content tc-job-cancel-modal">
          <div class="modal-body tc-cancel-message">
            {{ 'editServices' | translate }}
          </div>

          <div class="message-edit">
            {{ 'editMessage' | translate }}
          </div>
          <div class="tc-cancel-buttons">
            <button (click)="closePopUpForStaffEditJob()" class="no-button">
              {{ 'no' | translate }}
            </button>
            <button class="yes-button">
              <app-button-loader *ngIf="tcCancelling"></app-button-loader>
              <span (click)="downloadStaffTemplateForEdit()" class="proceed-edit">
                {{ 'proceed' | translate }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>


    <div
    class="modal fade"
    id="uploadingExcel"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-tc-cancel" role="document">
      <div class="modal-content tc-job-cancel-modal">
        <div class="modal-body tc-cancel-message">
          <span *ngIf="isUploadingExcel">{{ 'excelUploading' | translate }}</span>
          <span
            *ngIf="uploadSuccess && !isUploadingExcel"
            class="success-upload-excel-tc"
            >{{ 'uploadSuccessfully' | translate }}</span
          >
          <span
            *ngIf="!isUploadingExcel && !uploadSuccess"
            class="error-upload-excel-tc"
            >{{ 'uploadFailed' | translate }}</span
          >
        </div>
        <div class="spinner-container">
          <div *ngIf="isUploadingExcel" class="spinner"></div>
        </div>
        <div *ngIf="uploadSuccess" class="message-edit">
          {{ 'uploadIdSuccess' | translate }}
        </div>

        <div
          *ngIf="uploadSuccess && !isUploadingExcel"
          class="message-edit success-job-id"
        >
          {{ 'jobId' | translate }} : #{{ idCardJobId }}
        </div>

        <div *ngIf="!isUploadingExcel && !uploadSuccess" class="message-edit">
          {{ 'errorLocation' | translate }}
        </div>
        <div
          *ngIf="tcUploadErrors && tcUploadErrors.length > 0 && !uploadSuccess"
          class="error-tc-excel"
        >
          <div class="error-list-tc">
            <ul *ngIf="tcUploadErrors && tcUploadErrors.length > 0">
              <li *ngFor="let item of tcUploadErrors">
                {{ 'column' | translate }} {{ item.columnName }} - {{ 'row' | translate }}
                {{ item.row }}
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="!isUploadingExcel && !uploadSuccess" class="message-edit">
          {{ 'messageUploadAgain' | translate }}
        </div>
        <div class="tc-cancel-buttons">
          <button (click)="closePopUpForUploadingExcel()" class="ok-button">
            {{ 'ok' | translate }}
          </button>


            </div>
      </div>
    </div>
  </div>


  </div>